<template>
  <div v-if="anyItem">
    <div class="flex row">
      <va-list fit>
        <va-item :key="-1">
          <va-item-section side></va-item-section>
          <va-item-section>
            <va-item-label>{{ this.$t("tables.timesheetEntryHeadings.date") }}</va-item-label>
          </va-item-section>
          <va-item-section></va-item-section>
          <va-item-section side></va-item-section>
          <va-item-section side>
            <va-item-label>{{ this.$t("tables.timesheetEntryHeadings.days") }}</va-item-label>
          </va-item-section>
        </va-item>
        <template v-for="record in records">
          <va-item :key="record.sequence" clickable>
            <va-item-section side>
              <va-icon v-if="record.holiday === true" class="small-icon" small name="fa fa-calendar" style="font-size: 16px;" />
            </va-item-section>
            <va-item-section>
              <va-item-label>{{ dailyDate(record) }}</va-item-label>
            </va-item-section>
            <va-item-section>
              <va-slider
                pin
                :step="0.25"
                :min="0"
                :max="1"
                value-visible
                :color="sliderColour(record)"
                :disabled="disableEditing"
                v-model="record.days"
              />
              <!--  -->
              <!-- :label-value="`${record.days*100}% of a day`" -->
            </va-item-section>
            <va-item-section side></va-item-section>
            <va-item-section side>
              <va-item-label>{{ dailyTotal(record)}}</va-item-label>
            </va-item-section>
          </va-item>
        </template>
        <va-item :key="-2">
          <va-item-section></va-item-section>
          <va-item-section></va-item-section>
          <va-item-section side>
            <va-item-label>{{ this.$t("tables.timesheetEntryHeadings.total") }}</va-item-label>
          </va-item-section>
          <va-item-section side>
            <va-item-label>{{totalDays}}</va-item-label>
          </va-item-section>
        </va-item>
      </va-list>
    </div>
    <div v-if="showOpenButtons">
      <va-button
        style="float: right;"
        medium
        color="info"
        :disabled="disableButtons"
        @click="saveClicked()"
      >{{ $t('buttons.timesheets.save') }}</va-button>
      <va-button
        style="float: right;"
        medium
        color="info"
        :disabled="disableButtons"
        @click="submitClicked()"
      >{{ $t('buttons.timesheets.submit') }}</va-button>
    </div>
    <div v-else-if="showApproveButtons">
      <va-button
        style="float: right;"
        medium
        color="info"
        :disabled="disableButtons"
        @click="approveClicked()"
      >{{ $t('buttons.timesheets.approve') }}</va-button>
      <va-button
        style="float: right;"
        medium
        color="info"
        :disabled="disableButtons"
        @click="rejectClicked()"
      >{{ $t('buttons.timesheets.reject') }}</va-button>
    </div>
    <div v-else-if="showProcessButtons">
      <va-button
        style="float: right;"
        medium
        color="info"
        :disabled="disableButtons"
        @click="adjustClicked()"
      >{{ $t('buttons.timesheets.adjust') }}</va-button>
      <va-button
        style="float: right;"
        medium
        color="info"
        :disabled="disableButtons"
        @click="processClicked()"
      >{{ $t('buttons.timesheets.process') }}</va-button>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="flex xs12 xl12 mb-5">
        <div class="overview-tab__item d-flex align--center">
          <div class="overview-tab__item-icon fill-height mr-2">
            <timesheet-empty-icon />
          </div>
          <div v-if="mode === 'open'" class="text--bold">{{$t('messages.timesheets.emptyOpen')}}</div>
          <div v-if="mode === 'all'" class="text--bold">{{$t('messages.timesheets.emptyAll')}}</div>
          <div
            v-if="mode === 'tobeapproved'"
            class="text--bold"
          >{{$t('messages.timesheets.emptyToBeApproved')}}</div>
          <div
            v-if="mode === 'tobeprocessed'"
            class="text--bold"
          >{{$t('messages.timesheets.emptyToBeProcessed')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimesheetEmptyIcon from './TimesheetEmptyIcon'
import userCacheService from '../../api/userCacheService'

export default {
  name: 'timesheet-entries',
  props: {
    locked: Boolean,
    records: Array,
    mode: String,
  },
  components: {
    TimesheetEmptyIcon,
  },
  data () {
    return {}
  },
  computed: {
    totalDays () {
      var days = 0
      if (this.records !== null && this.records !== undefined) {
        for (var i = 0; i < this.records.length; i++) {
          days += parseFloat(this.records[i].days)
        }
      }
      console.log(days)
      return days.toFixed(2)
    },
    disableEditing () {
      return (
        this.locked ||
        !(
          this.showOpenButtons ||
          this.showApproveButtons ||
          this.showProcessButtons
        )
      )
    },
    disableButtons () {
      var empty = this.totalDays === 0
      return empty
    },
    showOpenButtons () {
      return this.mode === 'open' && userCacheService.isEmployee()
    },
    showApproveButtons () {
      return this.mode === 'tobeapproved' && userCacheService.isManager()
    },
    showProcessButtons () {
      return (
        this.mode === 'tobeprocessed' &&
        (userCacheService.isSuperAdmin() || userCacheService.isAdmin())
      )
    },
    anyItem () {
      return (
        this.records !== null &&
        this.records !== undefined &&
        this.records.length > 0
      )
    },
    fields () {
      return []
    },
  },
  methods: {
    sliderColour (day) {
      var colour = 'info'
      if (day.day === 'Sun' || day.day === 'Sat') {
        colour = 'gray'
      } else if (day.holiday) {
        colour = 'danger'
      }
      return colour
    },
    dailyDate (day) {
      return day.date
    },
    dailyTotal (day) {
      var dailyTotal = -1
      if (day.record_date === '') {
        dailyTotal = 0
      } else {
        dailyTotal = day.days
      }
      return dailyTotal.toFixed(2)
    },
    saveClicked () {
      this.$emit('saveClickedInTimesheet', Number(this.totalDays))
    },
    submitClicked () {
      this.$emit('submitClickedInTimesheet', Number(this.totalDays))
    },
    approveClicked () {
      this.$emit('approveClickedInTimesheet', Number(this.totalDays))
    },
    rejectClicked () {
      this.$emit('rejectClickedInTimesheet', Number(this.totalDays))
    },
    adjustClicked () {
      this.$emit('adjustClickedInTimesheet', Number(this.totalDays))
    },
    processClicked () {
      this.$emit('processClickedInTimesheet', Number(this.totalDays))
    },
    initialize () {},
  },
}
</script>

<style lang="scss">
.small-icon {
  font-size: 20px;
}
.overview-tab {
  &__item {
    height: 55px;

    &-icon {
      min-width: 65px;
      max-width: 65px;
    }
  }
}
</style>
